import toast from 'react-hot-toast';
import {
  authenticatedFetch,
  SessionExpiredError
} from 'src/utils/authenticatedFetch';

export const printApplication = async (ApplicationID: number | string, permit: number | string) => {
  const toastId = toast.loading('Preparing print...');
  try {
    const pdfPath = `/applications/${permit}/license_download/${ApplicationID}`;

    const response = await authenticatedFetch(pdfPath, {
      method: 'GET',
      headers: {
        Accept: 'application/pdf'
      }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'Failed to load license' }));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const printWindow = window.open(url);
    if (printWindow) {
      printWindow.addEventListener('load', () => {
        printWindow.print();
        window.URL.revokeObjectURL(url);
      });
    }

    toast.success('Print dialog opened!', { id: toastId });
  } catch (error) {
    if (error instanceof SessionExpiredError) {
      toast.dismiss(toastId);
      return;
    }
    console.error('Error printing application:', error);
    toast.error(error instanceof Error ? error.message : 'Failed to print application', { id: toastId });
  }
};
